module.exports = __webpack_public_path__ + "img/step9.4389297d.png";